import React, { useEffect, useState } from "react";
import { translate } from "../Services/translation";

export default function AlternativeVariantListItem(props) {
  const {
    Size,
    StockAmountBreak,
    Id,
    EAN,
    StockStatus,
    Price,
    RecommendedPrice,
    QuantityFieldId,
    addToCartList,
    getFormattedPrice,
    quantity,
    IsLoggedIn,
    PackageSize,
    ReplacementArticle,
    StockQuantity,
    ShouldDisplayOutletTag,
    ShouldDisplayCampaignTag,
    IsNews,
    FormattedRetailPrice,
    RetailPrice,
  } = props;

  const [inputValue, setInputValue] = useState(quantity);
  const maxValue = 999;
  const minValue = 0;
  let stockIcon = "";
  let stockText = "";
  let hidePurchase = StockStatus == 4;
  switch (StockStatus) {
    case 1:
      stockIcon = "stock-container--in";
      stockText =
        (StockQuantity > StockAmountBreak
          ? StockAmountBreak + "+"
          : StockQuantity) +
        " st " +
        translate("product.stockquantitydescription").toLowerCase();
      break;
    case 2:
      stockIcon = "stock-container--order";
      stockText = translate("stock.outofstockwithoutquantity");
      break;
    case 3:
      if (StockQuantity > 0) {
        stockIcon = "stock-container--in";
        stockText =
          (StockQuantity > StockAmountBreak
            ? StockAmountBreak + "+"
            : StockQuantity) +
          " st " +
          translate("product.stockquantitydescription").toLowerCase();
      } else {
        stockIcon = "stock-container--order";
        stockText = translate("stock.orderitem");
      }
      break;
    case 4:
      stockIcon = "stock-container--out";
      stockText = translate("product.notavailable");
    default:
      stockIcon = "stock-container--out";
      stockText = translate("stock.outofstockwithoutquantity");
  }

  if (hidePurchase) {
    stockIcon = "stock-container--out";
    stockText = translate("product.notavailable");
  }

  const onInputBlur = (e) => {
    let value = e.currentTarget.value;
    if (PackageSize > 1) {

      value = roundToNearestPackageSize(value);

      if (value < minValue || value == "") {
        value = minValue;
      } else if (value > maxValue) {
        value = StockQuantity;
      }
    } else {
      value = value
        .replace("e", "")
        .replace(".", "")
        .replace(",", "")
        .replace("+", "");
      value = +value;
      if (value > maxValue) {
        value = maxValue;
      } else if (value < minValue) {
        value = 1;
      }
    }
    setInputValue(value);
    addToCartList(Id, value, Price);
  };

  function roundToNearestPackageSize(num) {
    const remainder = num % PackageSize;
    if (remainder == 0)  return num;
    return Number(num) + (PackageSize - remainder);
  }

  return (
    <li>
      <div className="large-1 small-12 paragraph-xl columns">
        {Size && (
          <>
            <span className="hide-for-large paragraph-m title">
              {translate("alternativevariant.size")}:{" "}
            </span>
            <span>{Size}</span>
          </>
        )}
      </div>
      <div className="large-3 small-12 paragraph-l columns">
        {Id && (
          <>
            <span className="hide-for-large paragraph-m title">
              {translate("alternativevariant.articleno")}:{" "}
            </span>
            <span>{Id}</span>
          </>
        )}
      </div>
      <div className="large-2 small-12 paragraph-l columns">
        {EAN && (
          <>
            <span className="hide-for-large paragraph-m title">
              {translate("alternativevariant.ean")}:{" "}
            </span>
            <span>{EAN}</span>
          </>
        )}
      </div>
      <div className="large-2 small-12 paragraph-m columns display-flex-all">
        {IsLoggedIn && (
          <>
            <div className={stockIcon}></div>
            <span>{stockText}</span>
          </>
        )}
      </div>
      <div className="large-1 small-12 paragraph-m columns display-flex-all product-tag-container-variant-list">
        <div className={`${
              ShouldDisplayOutletTag ? "outlet" : ""
                  } ${ShouldDisplayCampaignTag ? "campaign-variant" : ""}`}>
                  {IsNews && !ShouldDisplayOutletTag &&(
                <div className="product-tag product-tag--success">
                  {translate("producttag.news")}
                </div>
              )}
              {ShouldDisplayOutletTag && (
                  <div className="product-tag product-tag--danger">
                    {translate("producttag.outlet")}
                  </div>
                )}
              {ShouldDisplayCampaignTag && (
                <div className="product-tag product-tag--grey">
                  {translate("producttag.campaign")}
                </div>
              )}
        </div>
      </div>
      <div className="large-3 small-12 display-flex-all">
        <div
       className={
        !hidePurchase
          ? `large-8 small-8 paragraph-xl columns alternative-list__container--price text--right`
          : `large-10 small-10 paragraph-xl columns alternative-list__container--price`
      }
        >        
          {IsLoggedIn && !hidePurchase ? (
            Price.TierPrices.length > 0 ? (
              <div className="text--right">
                {Price.TierPrices.map((tierPrice) => (
                  <div>
                    <div className="alternative-list__container--tier-price">
                      <div>
                        {tierPrice.NextMinimumQuantity
                          ? tierPrice.MinimumQuantity +
                            "-" +
                            tierPrice.NextMinimumQuantity +
                            "" +
                            tierPrice.UnitOfMeasurementTitle
                          : tierPrice.MinimumQuantity + "+"}
                      </div>
                      <div>
                        {getFormattedPrice(tierPrice.Price, Price.Currency.Id)}/
                        {tierPrice.UnitOfMeasurementTitle}
                      </div>
                    </div>
                    <span className="paragraph-xs">
                      {IsLoggedIn && translate("alternativevariant.excluding")}
                    </span>
                  </div>
                ))}
              </div>
            ) : (
              <>
                {FormattedRetailPrice != null && RetailPrice != 0 &&
                  <span className="retail-price">
                    {FormattedRetailPrice}
                  </span>
                }
                <div>
                  {Price &&
                    Price.Price &&
                    Price.Price.Price &&
                    getFormattedPrice(Price.Price.Price, Price.Currency.Id)}
                </div>
                <span className="paragraph-xs">
                  {translate("alternativevariant.excluding")}
                </span>
                {RecommendedPrice && (
                  <span className="paragraph-xs">{RecommendedPrice}</span>
                )}
              </>
            )
          ) : (
            ReplacementArticle != "" && (
              <div className="product-page__replacement-article">
                <span>{translate("product.replacementarticle")} </span>
                <a className="primary-link" href={ReplacementArticle}>
                  {translate("product.replacementarticlelink")}
                </a>
              </div>
            )
          )}
        </div>
        <div
          className="large-4 small-4 paragraph-l columns text--center"
          id={Id}
        >
          {IsLoggedIn && !hidePurchase && (
            <input
              id={QuantityFieldId}
              type="number"
              className="form__input product-detail__quantity-input"
              value={inputValue}
              onKeyDown={(e) => PackageSize > 1}
              onChange={(e) => setInputValue(e.target.value)}
              onBlur={(e) => onInputBlur(e)}
              min="0"
              max="999"
              maxLength="3"
            />
          )}
        </div>
      </div>
    </li>
  );
}
